import React from "react";
import { Button, Heading, Modal, RoundButton, Text } from "@foris/avocado-suite";
import styles from "./onboardingVideoModal.module.scss";
import { useTranslation } from "react-i18next";

interface OnboardingVideoModalProps {
  isOpen?: boolean;
  title?: string;
  description?: string;
  customContent?: React.ReactNode;
  videoUrl?: string;
  header?: React.ReactNode;
  actions?: React.ReactNode;
  onClose?: () => void;
}

const OnboardingVideoModal = ({
  isOpen = false,
  title,
  description,
  customContent,
  videoUrl,
  header,
  actions,
  onClose,
}: OnboardingVideoModalProps) => {
  const { t } = useTranslation();

  const handleOnClose = () => {
    onClose?.();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleOnClose}
      className={styles.onboardingVideoModal}
      header={
        <div className={styles.onboardingVideoModal_header}>
          {!!header && header}

          {!!videoUrl && <video width="100%" height="100%" src={videoUrl} controls></video>}

          <RoundButton
            className={styles.headerClose}
            variant="ghost"
            icon="close"
            onClick={handleOnClose}
          />
        </div>
      }
      actions={
        actions || (
          <>
            <Button onClick={handleOnClose}>{t("onboarding.actions.done")}</Button>
          </>
        )
      }
    >
      <div className={styles.onboardingVideoModal_content}>
        <Heading type="h1">{title}</Heading>

        {!!customContent && customContent}
        {!customContent && <Text type="lg">{description}</Text>}
      </div>
    </Modal>
  );
};

export default OnboardingVideoModal;
